// Helper for "Share to X" — opens an X (Twitter) intent in a new tab
// with the entry body excerpt + hashtags + the DiviDrip site URL
// pre-populated. No public page is involved: the share is purely
// text + the user's own tags turned into hashtags + a brand link
// back to twylightcrow.com so each share is also a low-friction
// backlink. Keeps Journal data private (login-gated).

const X_INTENT_BASE = 'https://twitter.com/intent/tweet';

// Public site URL we always tail with. X auto-collapses it to a
// 23-char t.co link in the rendered tweet, so a body excerpt of
// ~200 chars + 40 chars of hashtags + 6-char $TICKER + 26 chars for
// the URL leaves us safely under X's 280-char ceiling.
const SITE_URL = 'https://twylightcrow.com';

// X's hard tweet cap is 280. Reserve room for: site URL (~26),
// hashtags (~40 typical), $TICKER (~6), newlines (~4) → leaves us a
// safe 200-char body excerpt. Body is the only field we truncate.
const BODY_BUDGET_FOR_TEXT = 200;

function _bodyExcerpt(entry) {
  // Combine title + body so the X post reads as a complete thought.
  // Without this, an entry titled "$1 dividend" with body "Hope it
  // stays this way..." rendered as just the body and lost context.
  // Title is shown first because it's almost always the punchier line.
  const title = (entry.title || '').trim();
  const body = (entry.body || '').trim();
  let combined = '';
  if (title && body) combined = `${title} — ${body}`;
  else combined = title || body;
  combined = combined.replace(/\s+/g, ' ');
  if (combined.length <= BODY_BUDGET_FOR_TEXT) return combined;
  return combined.slice(0, BODY_BUDGET_FOR_TEXT - 1).trimEnd() + '…';
}

function _formatHashtags(tags = []) {
  return (tags || [])
    .map((t) => (t || '').replace(/[^a-zA-Z0-9_]/g, ''))
    .filter(Boolean)
    .map((t) => `#${t}`);
}

export function buildXShareText(entry) {
  const body = _bodyExcerpt(entry);
  const tickerTag = entry.ticker ? `$${entry.ticker.toUpperCase()}` : '';
  const userTags = _formatHashtags(entry.tags);
  // Always tail with #DiviDrip so the brand travels with the share.
  const tail = ['#DiviDrip', ...userTags].join(' ');
  // Layout: $TICKER body — tags — site URL
  const head = tickerTag ? `${tickerTag} ` : '';
  return `${head}${body}\n\n${tail}\n${SITE_URL}`.trim();
}

export function shareEntryToX(entry) {
  const text = buildXShareText(entry);
  // X will auto-extract the trailing URL into a card; we still pass
  // it via `text` (and not `url`) because that's what populates the
  // compose box for users who want to edit before posting.
  const url = `${X_INTENT_BASE}?text=${encodeURIComponent(text)}`;
  // open in a new tab so the user's session stays put
  window.open(url, '_blank', 'noopener,noreferrer');
}
